
import api from '../api';

export interface ContactInfo {
    fone: string
    email: string
    endereco: string
    nome: string
}

export const SystemConfigService = {
    getContactInfo: async (): Promise<ContactInfo> => {
        const { data } = await api.get<ContactInfo>('/system-config/public/contact-info')
        return data
    },
}
